import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const HERO_IMAGES = [
    "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=1920&q=80",
    "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=1920&q=80",
    "https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&w=1920&q=80"
];

const Typewriter = ({ text }) => {
    const [displayText, setDisplayText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [loopNum, setLoopNum] = useState(0);
    const [typingSpeed, setTypingSpeed] = useState(150);

    useEffect(() => {
        let timer = setTimeout(() => {
            const fullText = text;

            setDisplayText(isDeleting ? fullText.substring(0, displayText.length - 1) : fullText.substring(0, displayText.length + 1));

            setTypingSpeed(isDeleting ? 75 : 150);

            if (!isDeleting && displayText === fullText) {
                setTimeout(() => setIsDeleting(true), 2500);
            } else if (isDeleting && displayText === '') {
                setIsDeleting(false);
                setLoopNum(loopNum + 1);
            }
        }, typingSpeed);

        return () => clearTimeout(timer);
    }, [displayText, isDeleting, text]);

    return (
        <span className="typewriter">
            {displayText}
            <span className="cursor">|</span>
        </span>
    );
};

const Home = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prev) => (prev + 1) % HERO_IMAGES.length);
        }, 7000);
        return () => clearInterval(interval);
    }, []);

    return (
        <section className="hero" id="home">
            <div className="hero-overlay"></div>

            {/* 
              Removed mode="wait" to allow images to overlap during transition. 
              This eliminates the 'black flash' by keeping the old image visible 
              while the new one slides in.
            */}
            <AnimatePresence initial={false}>
                <motion.img
                    key={currentImageIndex}
                    src={HERO_IMAGES[currentImageIndex]}
                    alt="Gourmet Food"
                    className="hero-bg"
                    initial={{ opacity: 0, scale: 1.1 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                />
            </AnimatePresence>

            <div className="hero-content">
                <h1 className="hero-title" style={{ minHeight: '12rem' }}>
                    <Typewriter text="Taste The World In One Place" />
                </h1>
                <p className="hero-subtitle">
                    Experience authentic culinary masterpieces from every corner of the globe,
                    crafted by master chefs using traditional techniques.
                </p>
                <button
                    className="cta-button"
                    onClick={() => document.getElementById('menu').scrollIntoView({ behavior: 'smooth' })}
                >
                    Explore Menu
                </button>
            </div>
        </section>
    );
};

export default Home;
